import { useState, FC } from 'react';
import type { Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { useAsync } from 'react-use';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';
import { fetchUserInfo, fetchUserInfoDetails } from 'APIPackage/AuthModule/services/authApi';
import { UserRoleEnum } from 'APIPackage/AuthModule/enums/UserRoleEnum';
import { fetchPublicPortalURL } from 'APIPackage/MainModule/services/portalApi';
import { LOGIN } from 'CorePackage/MainModule/constants/localStorageNames';
import { userNotificationUnreadGetCount } from 'UserNotificationPackage/MainModule/actions/UserNotificationAction';

import { setUserAction, clearUserAction } from '../actions/authActions';
import { coreSetPublicPortalURL } from '../../../CorePackage/MainModule/actions/coreActions';

interface IAuthCheckProps {
  setUserInfo: (userInfo: IUserInfo) => void;
  clearUserData: () => void;
  setPublicPortalURL: (url: string) => void;
}

const AuthCheckWithoutStore: FC<IAuthCheckProps> = ({ children, setUserInfo, clearUserData, setPublicPortalURL }) => {
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useAsync(async () => {
    const allRoles = Object.values(UserRoleEnum);

    try {
      const userInfo = await fetchUserInfo();
      const params: { isTestUser: boolean } = await fetchUserInfoDetails();
      // const params = {
      //   isTestUser: true,
      // };
      const roles = userInfo?.roles?.filter(r => allRoles?.includes(r?.sysname));
      const useData: IUserInfo = {
        ...userInfo,
        userProfile: {
          ...userInfo.userProfile,
          isTestUser: params.isTestUser,
        },
        roles,
      };

      setUserInfo(useData);
      dispatch(userNotificationUnreadGetCount());

      const url = await fetchPublicPortalURL();

      setPublicPortalURL(url);
      sessionStorage.setItem(LOGIN, userInfo.userAccount.login);
    } catch (err) {
      clearUserData();
    } finally {
      setIsChecked(true);
    }
  }, []);

  if (isChecked) {
    return <>{children}</>;
  }

  return null;
};

const mapDispatchToProps = (dispatch: Dispatch<RootActions>) => ({
  setUserInfo: (userInfo: IUserInfo) => dispatch(setUserAction(userInfo)),
  clearUserData: () => dispatch(clearUserAction()),
  setPublicPortalURL: (url: string) => dispatch(coreSetPublicPortalURL(url)),
});

export const AuthCheck = connect(null, mapDispatchToProps)(AuthCheckWithoutStore);
